import * as React from 'react';
import classnames from 'classnames';

import s from './CardWrapper.module.scss';

interface CardWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export const CardWrapper: React.FC<CardWrapperProps> = ({ children, className }) => {
  return <div className={classnames(s.wrapper, className)}>{children}</div>;
};
